const NUMBER_PORTFOLIO_ID_VALID = 1
const IDS_PARAMS = [
  'bussinessAgeIds',
  'bussinessSizeIds',
  'excludeIds',
  'industryIds',
  'provinceIds',
]

export const isValidPortfolio = (params) => {
  const cloneParams = structuredClone(params)
  const isNumberPortfolioValid =
    Array.isArray(cloneParams.portfolioIds) &&
    cloneParams.portfolioIds.length === NUMBER_PORTFOLIO_ID_VALID
  const isSampleParam = isSampleParams(cloneParams)

  return isNumberPortfolioValid && isSampleParam
}

const isSampleParams = (params) => {
  const isEmptyArr = isEmptyArray(params)
  const hasScoreRange = hasSettingScore(params)

  return isEmptyArr && !hasScoreRange
}

const isEmptyArray = (params) => {
  return IDS_PARAMS.every((key) => params[key].length === 0)
}

const hasSettingScore = (params) =>
  [
    'CurrentCreditRiskScore',
    'CurrentPerformanceScore',
    'PreviousCreditRiskScore',
    'PreviousPerformanceScore',
  ].some((key) => {
    if (!params) return false
    const listCustomRanges = params.scoreLevel[key]?.ListCustomRanges || []
    const listLevelScoreChecked =
      params.scoreLevel[key]?.ListLevelScoreChecked || []
    return (
      !!listLevelScoreChecked.length ||
      listCustomRanges.some((item) => !!item.From || !!item.To)
    )
  })
